import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import get from "lodash/get";
import { NormalSearchBox } from "../../molecules/normal-searchbox";
import { searchV2 } from "../../helper/api";
import { LoadMoreButton } from "../../atoms/load-more-button";
import Loader from "../../atoms/loader";
// import CommonListPage from "../../molecules/common-list-page";
import GoogleSearchResults from "../../molecules/google-search";
import "./search.m.css";

const SearchPage = ({ data = {} }) => {
  const [searchResults, setSearchResults] = useState(null);
  const [searchItems, setSearchItems] = useState([]);
  useEffect(() => {
    if (data.query) {
      getSearchHandler(1);
    }
  }, []);

  async function getSearchHandler(start) {
    try {
      const res = await searchV2(encodeURIComponent(unescape(data.query)), start);
      console.log(res);
      await setSearchResults(res);
      await setSearchItems([...searchItems, ...res.items]);
    } catch (e) {
      console.log(e);
    }
  }
  return (
    <div styleName="search-container">
      <div className="full-width-with-padding" styleName="search-box">
        <NormalSearchBox />
        {data.query && searchResults ? (
          <h4 styleName="search-heading">
            Showing {searchItems.length} results for <span styleName="query">{`“${data.query}”`}</span> out of{" "}
            {searchResults.searchInformation.formattedTotalResults}
          </h4>
        ) : null}
      </div>
      {data.query && searchResults ? (
        <>
          <GoogleSearchResults data={searchItems} />
          <div styleName="load-more">
            {searchItems.length < 100 && get(searchResults, "queries.nextPage[0].startIndex", null) && (
              <LoadMoreButton onClick={() => getSearchHandler(searchResults.queries.nextPage[0].startIndex)} />
            )}
          </div>
          {/* <CommonListPage data={data} hideAuthorWithTime={true} /> */}
        </>
      ) : (
        <div styleName="empty">
          {!data.query && (
            <div>
              <img
                styleName="search-icon"
                // eslint-disable-next-line max-len
                src="https://images.assettype.com/newslaundry/2021-05/cd1b46a7-831e-47ff-8146-11a62d95ebaf/error_404.png"
                alt=""
              />
            </div>
          )}
          {data.query && !searchResults && (
            <div style={{ padding: "50px 0", margin: "50px 0" }}>
              <Loader color="#ec2227" width="80" />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

SearchPage.propTypes = {
  data: PropTypes.shape({
    query: PropTypes.string,
    total: PropTypes.number,
    stories: PropTypes.array,
    trendingCollection: PropTypes.object
  })
};

export { SearchPage };
